import { render, staticRenderFns } from "./ScholarshipsCreate.vue?vue&type=template&id=71887ac6"
import script from "./ScholarshipsCreate.vue?vue&type=script&lang=js"
export * from "./ScholarshipsCreate.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipsCreate.vue?vue&type=style&index=0&id=71887ac6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports